import React, { useState } from 'react';
import { authService } from '../../services/authService';

export default function SeedDataView() {
  const [loading,         setLoading]         = useState(false);
  const [loadingClear,    setLoadingClear]     = useState(false);
  const [result,          setResult]           = useState(null);
  const [error,           setError]            = useState('');

  const ejecutarSeed = async () => {
    if (!window.confirm('¿Cargar datos de prueba en Firebase? Se crearán/sobreescribirán los registros seed-c01…seed-c20, seed-a01…a15 y seed-o01…o24.')) return;
    setLoading(true); setError(''); setResult(null);
    try {
      const resp = await fetch('/.netlify/functions/seedData', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authService.authHeader() },
        body: JSON.stringify({}),
      });
      const data = await resp.json();
      if (!data.success) throw new Error(data.error || 'Error desconocido');
      setResult({ ...data, tipo: 'seed' });
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const limpiarSeed = async () => {
    if (!window.confirm('¿Eliminar todos los registros de prueba (seed-*)? Esta acción no se puede deshacer.')) return;
    setLoadingClear(true); setError(''); setResult(null);
    try {
      const resp = await fetch('/.netlify/functions/clearSeedData', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authService.authHeader() },
        body: JSON.stringify({}),
      });
      const data = await resp.json();
      if (!data.success) throw new Error(data.error || 'Error desconocido');
      setResult({ ...data, tipo: 'clear' });
    } catch (e) { setError(e.message); }
    finally { setLoadingClear(false); }
  };

  return (
    <div className="max-w-lg mx-auto space-y-6">
      <div className="bg-white rounded-2xl shadow-sm border p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center text-xl">🌱</div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">Datos de prueba</h2>
            <p className="text-xs text-gray-500">Solo visible para administradores</p>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-sm text-amber-800 space-y-1">
          <p className="font-bold">¿Qué hacen estas acciones?</p>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            <li><strong>Cargar:</strong> crea 20 clientes, 15 activos, 24 órdenes y 20 productos de prueba</li>
            <li><strong>Eliminar:</strong> borra todos los registros <code>seed-*</code> de todas las colecciones</li>
            <li>Los IDs comienzan con <code>seed-</code> para identificarlos fácilmente</li>
            <li>Cargar es <strong>idempotente</strong>: ejecutarlo varias veces no duplica datos</li>
          </ul>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm">
            <p className="font-bold">Error</p>
            <p>{error}</p>
          </div>
        )}

        {result && result.tipo === 'seed' && (
          <div className="bg-green-50 border border-green-200 text-green-800 rounded-xl px-4 py-3 text-sm">
            <p className="font-bold">Seed completado</p>
            <p>{result.mensaje}</p>
          </div>
        )}
        {result && result.tipo === 'clear' && (
          <div className="bg-green-50 border border-green-200 text-green-800 rounded-xl px-4 py-3 text-sm">
            <p className="font-bold">Datos eliminados</p>
            <p>{result.mensaje}</p>
          </div>
        )}

        <button
          onClick={ejecutarSeed}
          disabled={loading || loadingClear}
          className="w-full flex items-center justify-center gap-2 py-3 bg-amber-600 hover:bg-amber-700 disabled:opacity-50 text-white font-bold rounded-xl transition-colors"
        >
          {loading
            ? <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Cargando…</>
            : 'Cargar datos de prueba'
          }
        </button>

        <button
          onClick={limpiarSeed}
          disabled={loading || loadingClear}
          className="w-full flex items-center justify-center gap-2 py-3 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-bold rounded-xl transition-colors"
        >
          {loadingClear
            ? <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Eliminando…</>
            : 'Eliminar datos de prueba'
          }
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border p-6 space-y-3">
        <h3 className="font-bold text-gray-900">Próximos módulos Z v2.0</h3>
        <div className="space-y-2">
          {[
            { icon: '✅', label: 'Clientes', desc: 'CRUD completo con tabs (órdenes, equipos, contratos)', done: true },
            { icon: '✅', label: 'Órdenes de trabajo', desc: 'Kanban + lista con filtros y cambio de estado', done: true },
            { icon: '🔄', label: 'Facturas', desc: 'Creación, PDF y seguimiento de cobro', done: false },
            { icon: '🔄', label: 'Material y compras', desc: 'Catálogo, pedidos a proveedores, stock', done: false },
            { icon: '🔄', label: 'Sincronización StelOrder', desc: 'Doble escritura y migración de datos reales', done: false },
          ].map(item => (
            <div key={item.label} className="flex items-start gap-3 py-2 border-b border-gray-50 last:border-0">
              <span className="text-lg flex-shrink-0">{item.icon}</span>
              <div>
                <p className={`text-sm font-semibold ${item.done ? 'text-gray-900' : 'text-gray-500'}`}>{item.label}</p>
                <p className="text-xs text-gray-400">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
